import { Author } from "@hub/models/metadata/author";

export const ArtificialAuthor: Author = {
  name: "Authstrong Paceski",
  title: "Developer Advocate",
  avatar: "https://cdn.auth0.com/blog/auziros/authstrong.png",
  url: "https://developer.auth0.com/resources",
};
